<div class="details-body-wrapper">
  <app-orders
    [entity_id]="entity_id"
    [hideTitle]="false"
    [entity_type]="entity_type"
    [stage]="'client-order'"
  ></app-orders>
</div>
